import React from 'react';
import { Modal } from 'schola-components';
import PropTypes from 'prop-types';
import './edit-profile-modal.scss';
import EditProfileForm from '../edit-profile-form';
import { useResponsiveRender } from 'hooks/useResponsiveRender';

const EditProfileModal = ({ isVisible, onClose }) => {
  const { renderMobile: mobileRender } = useResponsiveRender({ breakpoint: 565 });

  return (
    <Modal
      isVisible={isVisible}
      className="account-settings-modal form_wrapper"
      data-testid="profileFormModal"
      onClose={mobileRender ? '' : onClose}>
      <EditProfileForm onClose={onClose} />
    </Modal>
  );
};

EditProfileModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default EditProfileModal;
